const oneDayMs = 1000 * 60 * 60 * 24;

/**
 * Calculates the number of days passed since a given date.
 * @param {string|Date} date - The start date.
 * @returns {number} The number of full days passed.
 */
export const getDaysSince = (date) => {
  if (!date) return 0;
  const start = new Date(date);
  const now = new Date();
  const diffMs = now - start;
  return Math.floor(diffMs / oneDayMs);
};

/**
 * Calculates the number of weeks passed since a given date.
 * @param {string|Date} date - The start date (e.g., user registration date).
 * @returns {number} The number of full weeks passed.
 */
export const getWeeksSince = (date) => {
  if (!date) return 0;
  const days = getDaysSince(date);
  return Math.floor(days / 7);
};

/**
 * Calculates a rotating index based on days passed.
 * @param {string|Date} startDate - The start date.
 * @param {number} cycleLength - The total number of items in the cycle.
 * @returns {number} The current index (0 to cycleLength - 1).
 */
export const getRotatingIndex = (startDate, cycleLength) => {
  if (!cycleLength || cycleLength <= 0) return 0;
  const days = getDaysSince(startDate);
  return days % cycleLength;
};
